import { panelLabelProjectNotShared } from "_constants";
import elementNotFoundImage from "assets/images/element_not_found.svg";

export const DetailPanelEmptyUsersList = () => {
  return (
    <div className="flex-container column align-center justify-center height-60">
      <img
        src={elementNotFoundImage}
        alt={panelLabelProjectNotShared}
        width="200px"
      />
      <span className="text-base-regular light-grey">
        {panelLabelProjectNotShared}
      </span>
    </div>
  );
};
